<template>
  <v-app v-if="isAuthenticated">
    <app-sidebar />
    <app-toolbar />
    <app-content />
    <connection-checker />
    <service-worker />
  </v-app>
</template>

<script>
import AppContent from '@/components/layout/AppContent'
import AppSidebar from '@/components/layout/AppSidebar'
import AppToolbar from '@/components/layout/AppToolbar'
import ConnectionChecker from '@/components/ConnectionChecker'
import ServiceWorker from '@/components/ServiceWorker'
import { mapGetters } from 'vuex'

export default {
  name: 'DefaultLayout',
  components: {
    AppSidebar,
    AppContent,
    AppToolbar,
    ConnectionChecker,
    ServiceWorker
  },
  computed: {
    ...mapGetters('AUTH', ['isAuthenticated', 'user'])
  }
}
</script>
